import { Routes } from '@angular/router';
import { DashboardRoutes } from '@core';
import { DashboardComponent } from './components';
import { loadMyGamesResolver } from '@my-games';

export const DashboardRouting: Routes = [
  {
    path: DashboardRoutes.ROOT,
    component: DashboardComponent,
    resolve: { loadMyGamesResolver }
  }
];
